/**
 * @author: lv.chen
 * @date: 2026/3/27
 * @desc: DataCompareBubble
 */
import React from 'react';
import classnames from 'classnames';
import { BubbleProps } from 'tea-component';
import { Bubble } from '@home/components/TeaComponents';
import DataCompareBubbleContent, {
  IDataCompareData,
  IDataCompareHelper,
} from '@intelligence/v3/components/DataCompareBubbleContent';
import { isEmpty } from '@intelligence/v3/utils/common';

import './index.scss';

interface IDataCompareBubbleProps extends BubbleProps, IDataCompareData, IDataCompareHelper {}

const DataCompareBubble: React.FC<IDataCompareBubbleProps> = (props) => {
  const {
    style,
    className,
    moduleType,
    entityType,
    icon,
    title,
    granularity,
    startDate,
    endDate,
    value,
    prevValue,
    valueFormatter,
    ...restProps
  } = props;

  if (isEmpty(startDate) || isEmpty(endDate) || isEmpty(value) || isEmpty(prevValue)) {
    return props.children as React.ReactElement;
  }

  return (
    <Bubble
      {...restProps}
      style={style}
      className={classnames('dbi-bubble-max-width dbi-data-compare-bubble', className)}
      dark
      arrowPointAtCenter
      content={
        <DataCompareBubbleContent
          moduleType={moduleType}
          entityType={entityType}
          icon={icon}
          title={title}
          granularity={granularity}
          startDate={startDate}
          endDate={endDate}
          value={value}
          prevValue={prevValue}
          valueFormatter={valueFormatter}
        />
      }
    >
      {
        React.Children.map(props.children as React.ReactElement, (child) => {
          return React.cloneElement(child, {
            style: {
              ...child?.props?.style,
              cursor: 'pointer',
            },
          });
        }) as unknown as any
      }
    </Bubble>
  );
};

export type { IDataCompareData, IDataCompareHelper };

export default DataCompareBubble;
